import { createContext } from 'react';
import { Category } from '../interfaces';

export default createContext<Category[]>([]);
